<div fxLayout="column" fxLayoutAlign="center center">
<mat-card class="mat-elevation-z5" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
  <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_NOBD.TITULO' | translate}}</h2>
  <mat-divider id="matDiver"></mat-divider>
  <div fxLayout="row" fxLayoutAlign="start center" class="mt-20 mb-20">
    <mat-icon class="s-30 mr-20">filter_1</mat-icon>
    <div class="h3 secondary-text"><b>{{'CERTIFICAR.COLABORADORES.CARD_NOBD.PASOS.1' | translate}}</b></div>
  </div>
  <div fxLayout="row" fxLayoutAlign="center stretch" class="mb-20">
    <a mat-fab class="primary" matTooltip="{{'CERTIFICAR.COLABORADORES.CARD_NOBD.TOOLTIP' | translate}}"
      [href]="urlAssets + 'platform/plantillasBD/' + instituto + '/CollaboratorsListTemplate_' + idiomaActual + '.xlsm'" download (click)="ModalArchivo()">
      <!-- {{'CERTIFICAR.COLABORADORES.CARD_NOBD.FILE' | translate}} -->
      <mat-icon>save_alt</mat-icon>
    </a>
  </div>
  <mat-divider id="matDiver"></mat-divider>
  <div fxLayout="row" fxLayoutAlign="start center" class="mt-20 mb-20">
    <mat-icon class="s-30 mr-20">filter_2</mat-icon>
    <div class="h3 secondary-text"><b>{{'CERTIFICAR.COLABORADORES.CARD_NOBD.PASOS.2' | translate}}</b></div>
  </div>
</mat-card>
</div>
